module.exports = __webpack_public_path__ + "assets/img/Type E (41).ad165f8f.jpg";